import { Component, OnInit } from '@angular/core';
import { UserService, User } from "app/services/user.service";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { BaseComponent } from "app/components/base.component";
import { NotificationsService } from "angular2-notifications";
import { PaginationService } from "app/services/pagination.service";
import * as _ from 'underscore';

@Component({
	selector: 'app-users',
	templateUrl: './users.component.html',
	styleUrls: ['./users.component.css']
})
export class UsersComponent extends BaseComponent implements OnInit {
	users: any;
	private allItems: User[];
	private allItemsOri: User[];
    pager: any = {};
    pagedItems: any[];
    q: string = '';

	constructor(
		private userService: UserService,
		private router: Router,
		private route: ActivatedRoute,
		private notificationsService: NotificationsService,
		private paginationService: PaginationService,
	) {
		super();
	}

	ngOnInit() {
		this.userService.getUsers().subscribe(users => {
			this.users = users.sort((a,b)=> {
				if(a.fullname == b.fullname)
				{
					return 0;
				}
				return a.fullname.toLowerCase() < b.fullname.toLowerCase() ? -1 : 1;
			})
			this.allItemsOri = _.clone(this.users);
			this.allItems = _.clone(this.users);
			this.setPage(1);
		});
	}

	onDeleteClick(id){
		var self = this;
		if(confirm("Are you sure?")){
			this.userService.deleteUser(id).then(function(){
				self.notificationsService.error("Deleted", "1 User deleted, please delete the user authentication data on Firebase console manually." );
			});
		}
	}

	setPage(page: number) {
        // get pager object from service
        this.pager = this.paginationService.getPager(this.allItems.length, page);

        // get current page of items
        this.pagedItems = this.allItems.slice(this.pager.startIndex, this.pager.endIndex + 1);
	}

	filter_result(){
		if(this.q) {
			this.allItems = this.allItemsOri.filter(item => {
				var regex = new RegExp( this.escapeRegExp(this.q), 'gi' );
				var name = regex.test(item.fullname + ' ' + item.email);

				return name;
			})
		}
		else
		{
			this.allItems = this.allItemsOri;
		}
		this.setPage(1);
	}

	escapeRegExp(str) {
		return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
	}

}



// WEBPACK FOOTER //
// D:/www/kh_indesso_web/src/app/components/user/users/users.component.ts